<template>
  <router-link
    :to="getPath(`/ticket/${product.id}`)"
  >
  <div class="d-flex product-card" @click="viewItem">
    <v-img :src="image" width="106" height="106" class="product-card__image flex-grow-0" />
    <div
      class="ml-3 product-card__text d-flex flex-column"
    >
      <p class="text-h5 mb-0 single-line product-card__title">
        {{ product.title }}
      </p>
      <span class="text-h4 text-caption product-card__description body-text--text">
        {{ cleanHtmlTags(product.descriptionHtml.split('\n')[0]) }}
      </span>
      <p
        v-if="isTicketPriceEnable"
        class="text-h6 text-price mt-3 mb-0 product-card__price body-text--text"
      >
        {{price}}
      </p>
    </div>
  </div>
  </router-link>
</template>

<script lang="ts">
import Vue, { PropType } from 'vue'
import Options from 'vue-class-component'

import { getPath, cleanHtmlTags, toTwoDp } from '@/utils/general-utils'
import { GRAY } from '@/utils/constants'
import { mapGetters } from 'vuex'
import { CollectionProduct } from '@/utils/shopify'

@Options({
  props: {
    product: Object as PropType<CollectionProduct>,
  }, 
  computed: mapGetters([
    'tag',
    'isTicketPriceEnable',
  ])
})
export default class ProductCard extends Vue {
  GRAY = GRAY;
  getPath = getPath;
  cleanHtmlTags = cleanHtmlTags;
  product!: CollectionProduct
  tag!: string
  isTicketPriceEnable!: boolean;

  get image():string {
    const productImage = this.product.featuredImage?.src
    return productImage ?? GRAY
  }

  get price(): string {
    const maxPrice = this.product.priceRange.maxVariantPrice.amount
    const minPrice = this.product.priceRange.minVariantPrice.amount
    
    if (minPrice === '0.0' && maxPrice === '0.0') {
      return 'Complimentary'
    } else if (minPrice === '0.0' && maxPrice !== '0.0') {
      return `Complimentary - $ ${toTwoDp(maxPrice)}`
    } else {
      return `$ ${toTwoDp(minPrice)} - $ ${toTwoDp(maxPrice)}`
    }
  }

  viewItem(): void {
    this.$gtm.trackEvent({
      event: 'gtm_selectticket',
      gtm_pm_datasource: this.$store.getters.shopName,
      stage: 'Ticket Selection',
      action: 'click',
      event_parameters: {
        gtm_pm_ticketname: this.product.title,
      }
    })
  }
}
</script>

<style lang="scss">
$border: 0.3px solid #c4c4c4;
$border-radius: 12px;
$card-padding: 12px;
$card-padding-bottom: 20px;

.product-card {
  border-radius: $border-radius;
  padding: $card-padding;
  overflow: hidden;
  text-decoration: none;
  color: black !important;
  background: #FFFFFF;
  box-shadow: 0px 4px 10px #a3a3a33d;
  border-radius: 12px;
  width: 97%;
  margin-left: 7px;
  margin-right: 5px;
  margin-top: 5px;
  &__text {
    min-width: 0;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    flex-grow: 1;
  }
  &__description {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }
  &__image {
    margin-left: #{-1 * $card-padding};
    margin-top: #{-1 * $card-padding};
    margin-bottom: #{-1 * $card-padding-bottom};
    min-width: 106px;
    width: 106px;
    height: 106px;
  }
  &__price {
    font-weight: 600 !important;
  }
}
</style>
